export default {
  data() {
    return {
      activities: [{
        content: "丹东北国之春农业科技有限公司专家工作站正式揭牌成立。与中科院沈阳应用生态研究所研究员、树木园常务副主任、博士生导师陈玮对接合作，促进企业科研成果转化，增强企业竞争力，大力推进农业现代化水平提升。",
        timestamp: "2020年"
      }, {
        content: "与辽宁省农科院、沈阳市农科院、丹东农科院以及丹东地区近40个草莓产业相关单位组建了“辽宁北国之春草莓产业产学研联盟”。",
        timestamp: "2021年"
      }, {
        content: "成功申报了省科技厅的“揭榜挂帅-科技攻关项目",
        timestamp: "2022年3月"
      }]
    };
  }
};